export default __webpack_public_path__ + "static/media/hide.c21377ed.svg";